module.exports = __webpack_public_path__ + "static/img/1111.36c614e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/notice/1111.png
// module id = 6m2N
// module chunks = 1